type GenderOption = { value: string; label: string };

type GenderRestrictionResult<T extends GenderOption> = {
  genderOpts: T[];
  defaultGender: string;
};

export function normaliseGenderCode(
  gender: { code: string } | string | null | undefined
): 'M' | 'F' | null {
  const code = typeof gender === 'string' ? gender : gender?.code;
  if (code === 'male' || code === 'M') return 'M';
  if (code === 'female' || code === 'F') return 'F';
  return null;
}

export function getGenderOptionsForRestriction<T extends GenderOption>(
  genderSpecific: 'M' | 'F' | null,
  allOptions: T[]
): GenderRestrictionResult<T> {
  if (genderSpecific === 'F') {
    return {
      genderOpts: allOptions.filter((o) => o.value === 'female' || o.value === 'neutral'),
      defaultGender: 'female',
    };
  }
  if (genderSpecific === 'M') {
    return {
      genderOpts: allOptions.filter((o) => o.value === 'male' || o.value === 'neutral'),
      defaultGender: 'male',
    };
  }
  return { genderOpts: allOptions, defaultGender: '' };
}
